export { adaptRelationValue } from './adaptRelationValue';
export { normalizeRelationList } from './normalizeRelationList';



// WEBPACK FOOTER //
// ./src/utils/forms/EmergencyContact/index.js